import React, { useState } from "react";
import PropTypes from "prop-types";
import { SYSTEM_ADMIN_WORKSPACES } from "constants/routes";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setRedirectedWorkspace } from "slices/systemAdmin/systemAdminSlice";

const UsersItemWorkspace = ({ workspaceName }) => {
  const [hover, setHover] = useState(false);
  const dispatch = useDispatch();
  return (
    <Link
      to={SYSTEM_ADMIN_WORKSPACES}
      onClick={() => dispatch(setRedirectedWorkspace(workspaceName))}
    >
      <span
        title={workspaceName}
        className={hover ? "hovered" : ""}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {workspaceName}
      </span>
    </Link>
  );
};

export default UsersItemWorkspace;

UsersItemWorkspace.propTypes = {
  workspaceName: PropTypes.string.isRequired,
};
